import React from "react";

const DeleteCategoryAttributeModal = ({
  isDeleteModalOpen,
  toggleModal,
  handleDelete,
  selectedAttribute,
}) => {
  return isDeleteModalOpen ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full h-full overflow-y-auto bg-black bg-opacity-50">
      <div className="relative w-full max-w-md p-4 max-h-full">
        <div className="relative p-4 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Delete Category Attribute
          </h2>
          <p className="mt-2">
            Are you sure you want to delete the attribute "{selectedAttribute?.name}"?
          </p>
          <div className="flex justify-end mt-4">
            <button
              onClick={handleDelete}
              className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 mr-2"
            >
              Yes, Delete
            </button>
            <button
              onClick={toggleModal}
              className="text-gray-500 hover:text-gray-700"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default DeleteCategoryAttributeModal;
